import acceptableUse from '../../../../docs/legal/acceptable-use.md?raw';
import dpa from '../../../../docs/legal/dpa.md?raw';
import privacyPolicy from '../../../../docs/legal/privacy-policy.md?raw';
import termsOfService from '../../../../docs/legal/terms-of-service.md?raw';

/**
 * The legal documents, as Markdown, from their single source of truth.
 *
 * `docs/legal/` is where these are drafted and reviewed; the dashboard imports
 * them with Vite's `?raw` so the page a user agrees to and the file counsel
 * reviews cannot drift apart. There is deliberately no second copy.
 *
 * Every one of these is a draft — see `docs/legal/README.md` for the review
 * gate and the unresolved placeholders. `LegalPage` says so on screen.
 */

export type LegalDocumentSlug =
  | 'terms-of-service'
  | 'privacy-policy'
  | 'acceptable-use'
  | 'dpa';

export interface LegalDocument {
  slug: LegalDocumentSlug;
  label: string;
  markdown: string;
}

export const LEGAL_DOCUMENTS: readonly LegalDocument[] = [
  { slug: 'terms-of-service', label: 'Terms of Service', markdown: termsOfService },
  { slug: 'privacy-policy', label: 'Privacy Policy', markdown: privacyPolicy },
  { slug: 'acceptable-use', label: 'Acceptable Use Policy', markdown: acceptableUse },
  { slug: 'dpa', label: 'Data Processing Addendum', markdown: dpa },
];

export function legalDocumentBySlug(slug: string): LegalDocument | undefined {
  return LEGAL_DOCUMENTS.find((document) => document.slug === slug);
}
